import { route } from "@circle-react/lib/routes/define";

export const settingsHomeRoutes = {
  index: route("/settings", {
    title: "Settings",
    requires: "admin",
    description:
      "Top-level admin settings landing page. Default redirect target when a more specific settings page is unavailable or feature-gated off for the current community.",
  }),
};
